// extracted by mini-css-extract-plugin
export var iLink = "HamburgerMenu-module--iLink--9ee30";
export var infoLinks = "HamburgerMenu-module--infoLinks--d31a1";
export var innerNavList = "HamburgerMenu-module--innerNavList--84b10";
export var linksContainer = "HamburgerMenu-module--linksContainer--87e6e";
export var opacity = "HamburgerMenu-module--opacity--b9122";
export var pLink = "HamburgerMenu-module--pLink--cc6fe";
export var pageLinks = "HamburgerMenu-module--pageLinks--3e1ee";